import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import { Box, Grid, IconButton, InputAdornment } from "@mui/material";
import { useState } from "react";
import {
  Button,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";

const EditToolbar = (props: any) => {
  const { reset } = useFormContext();
  const { success, error, info } = useNotify();
  const { getValues, formState } = useFormContext();
  const isDirty = formState.isDirty;

  const record = useRecordContext();
  const id = record?.id;
  const handleUndo = () => {
    reset();
    //set isDirty to false
    success("Changes have been cancel");
  };

  const saveData = () => {
    const reqUrl = "banks/actions/edit";

    const formData = isDirty ? getValues() : null;
    if (formData) {
      const saveFormData = {
        bankSolgan: formData.sSlogan,
        welcomeMsg: formData.sWelcomeMsg,
        saveType: "welcome",
      };
      if (!saveFormData?.bankSolgan) {
        error("Welcome Headline is required");
        return;
      }
      if (!saveFormData?.welcomeMsg) {
        error("Welcome Message is required");
        return;
      }

      sendRequest(reqUrl, { id: id, data: saveFormData }).then((res) => {
        if (res?.code == 200) {
          success("Saved successfully");
          reset(formData);
        } else {
          error("Error saving " + res?.message);
        }
      });
    } else {
      error("Error saving description: No data to save");
    }
  };
  return (
    <Box
      sx={{
        display: "block",
        mt: "2px",
        borderRadius: "0px",
        paddingTop: "0px",
      }}
    >
      <Toolbar
        {...props}
        sx={{
          background: "#fff",
          justifyContent: "space-between",
          // border: "1px solid red",
          borderTop: "1px solid #e0e0e0",
          padding: "0px",
          marginTop: "10px",
          "&.MuiToolbar-root.RaToolbar-root": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
        }}
      >
        <CustomButtonCancel label="Undo" onClick={handleUndo} />
        {/* <SaveButton /> */}
        <CustomButtonSave
          variant="contained"
          color="primary"
          onClick={saveData}
          disabled={!isDirty}
          sx={{
            width: "120px",
          }}
        />
      </Toolbar>
    </Box>
  );
};

const CustomLinkField = ({ ...props }) => {
  const record = useRecordContext();
  const [link, setLink] = React.useState(record?.[props?.source] || "");
  const { success, error } = useNotify();

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    success("Link copied to clipboard");
  };
  return (
    <TextInput
      source={props?.source}
      label={props?.label}
      name={props?.name}
      variant="outlined"
      value={link}
      sx={{
        width: "100%",
        "& input.Mui-readOnly": {
          // backgroundColor: "#ddd",
          // borderRadius: "10px",
          color: "#00000061",
        },
      }}
      InputProps={{
        readOnly: true,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={"Copy URL"}
              onClick={handleCopy}
              edge="end"
              sx={{ marginLeft: "0px" }}
            >
              <CopyAllOutlined />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

const WelcomeEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();

  if (!record) return <div>Loading...</div>;
  return (
    <SimpleForm toolbar={<EditToolbar />}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        {/* welcome_page */}
        {/* Consumer Portal URL for Sign-Up , URL with a copy link */}
        <CustomLinkField
          source="applicationUrl"
          label="Consumer Portal URL for Sign-Up"
          // link={record?.applicationUrl}
        />
        {/* Consumer Portal URL for Log-In */}
        <CustomLinkField
          source="loginUrl"
          label="Consumer Portal URL for Log-In"
          // link={record?.loginUrl}
        />
        {/* Business URL for Sign-Up */}
        <CustomLinkField
          source="businessSignUrl"
          label="Business URL for Sign-Up"
          // link={record?.businessSignUrl}
        />
        {/* Business URL for Log-In */}
        <CustomLinkField
          source="bussinessLoginUrl"
          label="Business URL for Log-In"
          // link={record?.bussinessLoginUrl}
        />
        {/* Welcome Headline */}
        <HmTextInput
          source="sSlogan"
          label="Welcome Headline"
          validate={[required()]}
          readOnly={isEdit ? false : true}
        />
        {/* Welcome Message */}
        <HmTextInput
          source="sWelcomeMsg"
          label="Welcome Message"
          sx={{
            "& .MuiInputBase-root": {
              padding: 0,
            },
          }}
          validate={[required()]}
          multiline
          rows={4}
          maxRows={4}
          readOnly={isEdit ? false : true}
        />
      </Box>
    </SimpleForm>
  );
};

const Welcome = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Welcome"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<WelcomeEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default Welcome;
